import Box from "@mui/material/Box";
import { IconContext } from "react-icons";
import { FiX } from "react-icons/fi";
import { IoIosArrowForward, IoMdAdd, IoMdOpen } from "react-icons/io";
import {
  AddButton,
  Assignment,
  AssignmentList,
  ButtonList,
  ButtonRow,
  ChapterReactButton,
  ConfirmButton,
  Container,
  Content,
  Deadline,
  DeleteButton,
  DocButton,
  DocIframe,
  Done,
  Duty,
  ExpandCard,
  Gap,
  HorizontalLeft,
  HorizontalStart,
  IconContainer,
  LeftContainer,
  LeftContent,
  LeftTitle,
  Member,
  RightContainer,
  RightDescription,
  RightDescription1,
  RightTitle,
  SmallText,
  Step,
  Title,
  TitleDescription,
  TopicDescription,
  TopicTitle,
  YellowText,
} from "./style";

import Button from "@mui/material/Button";

import React, { useContext, useEffect, useState } from "react";
import DocPNG from "../../img/doc-img.png";
// import ReactCSSTransitionGroup from "react-transition-group";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TextField from "@mui/material/TextField";
import { observer } from "mobx-react-lite";
import { useHistory, useParams } from "react-router-dom";
import { getCoEditDoc } from "../../services/MilestoneService";
import { planList } from "../Milestone/constant";
import SimpleInput from "./../../components/input/SimpleInput";
import Modal from "./../../components/Modal";
import Tiptap from "./../../components/RichTextEditor/TipTapEditor";
import { RootStoreContext } from "./../../store";

const MilestoneDetail = () => {
  const { MilestoneDetailStore, LoginStore, MilestoneStore } =
    useContext(RootStoreContext);
  const {
    visible,
    closeModal,
    openModal,
    updateData,
    member,
    scope,
    createNewTask,
    deadline,
    assignmentList,
    deleteTask,
    init,
    myPosition,
    teamId,
    docUrl,
    textContent,
    setTextContent,
    createNewDoc,
    updateTask,
    companyUrl,
    setCompanyUrl,
  } = MilestoneDetailStore;
  const { currentPlanIndex, getcurChapter } = MilestoneStore;
  const { user } = LoginStore;
  const { index } = useParams();
  const {
    title,
    subtitle,
    referList,
    chapterDescription,
    menutitle,
    tasktext,
  } = planList[index];
  const history = useHistory();
  const [hintVisible, setHintVisible] = useState(true);
  const [content, setContent] = useState(textContent);
  const [docKey, setDocKey] = useState(false);

  // const CLIENT_ID =
  //   "241824082703-9p6jev51lq8fkg3ok4cepmg8p50vrrc8.apps.googleusercontent.com";
  // const API_KEY = "AIzaSyAZtVjxcRQ2HFWAF-eGNdkpzF5qxBhel9M";

  // // Array of API discovery doc URLs for APIs used by the quickstart
  // const DISCOVERY_DOCS = [
  //   "https://docs.googleapis.com/$discovery/rest?version=v1",
  // ];

  // // Authorization scopes required by the API; multiple scopes can be
  // // included, separated by spaces.
  // const SCOPES = "https://www.googleapis.com/auth/documents";

  useEffect(() => {
    updateData("chapter", index);
    getCoEditDoc(index)
      .then((value) => {
        setContent(value.content);
        setDocKey(value.docKey);
        updateData("textContent", value.content);
        console.log(value);
      })
      .catch(console.log);
  }, [index]);
  useEffect(() => {}, [assignmentList.length, docUrl, companyUrl, textContent]);
  // useEffect(() => {
  //   window.onGoogleScriptLoad = () => {
  //     window.gapi.load("client:auth2", () => {
  //       (async () => {
  //         await window.gapi.client.init({
  //           apiKey: API_KEY,
  //           clientId: CLIENT_ID,
  //           discoveryDocs: DISCOVERY_DOCS,
  //           scope: SCOPES,
  //         });
  //         // setIsSignIn(window.gapi.auth2.getAuthInstance().isSignedIn.get());
  //       })();
  //     });
  //   };
  //   (function () {
  //     const id = "google-js";
  //     const src = "https://apis.google.com/js/platform.js";

  //     //we have at least one script (React)
  //     const firstJs = document.getElementsByTagName("script")[0];

  //     //prevent script from loading twice
  //     if (document.getElementById(id)) {
  //       return;
  //     }
  //     const js = document.createElement("script");
  //     js.id = id;
  //     js.src = src;
  //     js.onload = window.onGoogleScriptLoad;
  //     firstJs.parentNode.insertBefore(js, firstJs);
  //   })();
  // }, []);

  // const createDoc = async () => {
  //   // try {
  //   await window.gapi.auth2.getAuthInstance().signIn();

  //   // if (window.gapi.auth2.getAuthInstance().isSignedIn.get()) {
  //   // setIsSignIn(true);
  //   const { result } = await window.gapi.client.docs.documents.create({
  //     title: `SUSU platform (${new Date().toLocaleString()})`,
  //   });
  //   updateData(
  //     "docUrl",
  //     `https://docs.google.com/document/d/${result.documentId}/edit`
  //   );
  //   const docData = {
  //     leaderUrl: `https://docs.google.com/document/d/${result.documentId}/edit`,
  //     teamId,
  //     chapter: index,
  //   };
  //   createNewDoc(docData);
  // };
  return (
    <div>
      <Container>
        <Step>
          <YellowText to="/Milestone">STEP 1</YellowText>
          <Gap />
          <SmallText to="/Milestone">創業沙盤歷程</SmallText>
          <Gap />
          <IconContext.Provider value={{ color: "#AEAEAE" }}>
            <IoIosArrowForward />
          </IconContext.Provider>
          <Gap />
          <YellowText>STEP 2</YellowText>
          <Gap />
          <SmallText>編輯團隊商業計畫</SmallText>
        </Step>
        <Title>{title}</Title>
        <TitleDescription>{subtitle}</TitleDescription>
        <ButtonList>
          {chapterDescription && (
            <ChapterReactButton
              onClick={() => {
                history.push(`/${menutitle}`);
              }}
            >
              章節互動
            </ChapterReactButton>
          )}
        </ButtonList>
        <Content>
          <LeftContainer>
            <LeftTitle>參考條目</LeftTitle>
            {referList.map(({ link, text }) => (
              <LeftContent href={link}>{text}</LeftContent>
            ))}
          </LeftContainer>
          <RightContainer>
            {hintVisible && (
              <ExpandCard>
                <div>
                  <TopicTitle>應該如何開始書寫商業計畫書呢?</TopicTitle>
                  {tasktext ? (
                    <TopicDescription>{tasktext}</TopicDescription>
                  ) : (
                    <TopicDescription>
                      請團隊成員各自完成右上角章節互動內容，再共同討論心得。
                      <br />
                      <br />
                      1.分配各項任務給團隊成員，大家一同協力完成。
                      <br />
                      2.將這些內容整理成章節，並把網址貼到下方連結。
                      <br />
                      3.點選確認完成，成功繳交本章內容。
                      <br />
                      <br />
                      左邊是一些可參考的文件，如果遇到瓶頸，除了詢問助教外，可以點進去參考看看該如何實作！,
                    </TopicDescription>
                  )}
                </div>
                <IconContainer
                  onClick={() => {
                    setHintVisible(false);
                  }}
                >
                  <IconContext.Provider value={{ size: 21, color: "#C8C8C8" }}>
                    <FiX />
                  </IconContext.Provider>
                </IconContainer>
              </ExpandCard>
            )}

            <RightTitle>STEP 1 工作分配</RightTitle>
            <Assignment>
              <Member>團隊成員</Member>
              <Duty>負責範圍</Duty>
              <Deadline>截止日期</Deadline>
              <Done>是否完成</Done>
              <Done>刪除</Done>
            </Assignment>
            {assignmentList.map(
              ({ scope, member, deadline, complete, key }, index) => (
                <AssignmentList key={`assignment_${index}`}>
                  <Member>{member}</Member>
                  <Duty>{scope}</Duty>
                  <Deadline>{deadline.toLocaleDateString()}</Deadline>
                  <Done>
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      checked={complete}
                      onChange={(e) => {
                        updateTask(key, e.target.checked);
                      }}
                    />
                  </Done>
                  <Done>
                    <DeleteButton
                      size={15}
                      onClick={() => {
                        deleteTask(key);
                      }}
                    />
                  </Done>
                </AssignmentList>
              )
            )}

            <div style={{ textAlign: "right", marginTop: "20px" }}>
              <AddButton
                onClick={() => {
                  openModal();
                }}
              >
                <IconContext.Provider value={{ size: 30, color: "#4A4A4A" }}>
                  <IoMdAdd />
                </IconContext.Provider>
              </AddButton>
            </div>
            <HorizontalLeft>
              <RightTitle>STEP 2 文件編輯 &nbsp;</RightTitle>
              {/* {docUrl && (
                <a href={docUrl} target="_blank" rel="noreferrer">
                  <IconContext.Provider value={{ size: 21, color: "#4A4A4A" }}>
                    <IoMdOpen />
                  </IconContext.Provider>
                </a>
              )}
              &nbsp; &nbsp; &nbsp;
              <RightDescription1>
                (僅能輸入一次連結，請謹慎輸入！)
              </RightDescription1> */}
            </HorizontalLeft>
            <Gap />
            <div>
              <Tiptap
                name={user.displayName}
                team={teamId}
                init={content}
                content={content}
                setContent={setContent}
              />
              <Button
                onClick={() => {
                  setTextContent(index, content, docKey);
                }}
              >
                儲存
              </Button>
              <Gap />
              <Gap />
              <Gap />
              {title === "Ch10 總結" && (
                <HorizontalStart>
                  <div>
                    <RightDescription>輸入團隊的公司網址 :</RightDescription>
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <SimpleInput
                      value={companyUrl}
                      onChange={(e) => {
                        updateData("companyUrl", e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    onClick={() => {
                      setCompanyUrl();
                    }}
                  >
                    儲存
                  </Button>
                </HorizontalStart>
              )}
            </div>
            <RightTitle>STEP 3 文件完成</RightTitle>
            <RightDescription>
              為了確認大家的進度，當各位成功分配工作，並完成checklist且點按是否完成鈕，方可進入下一章節。
            </RightDescription>
            <Box mt={4} ml={3}>
              {!!assignmentList.length &&
              assignmentList.every((assignment) => assignment.complete) ? (
                <ChapterReactButton
                  onClick={() => {
                    history.push(`/Milestone`);
                    updateData("docUrl", "");
                  }}
                >
                  確認完成
                </ChapterReactButton>
              ) : (
                <ConfirmButton>確認完成</ConfirmButton>
              )}
            </Box>
            <RightDescription>&nbsp;</RightDescription>
          </RightContainer>
        </Content>
      </Container>
      <Modal visible={visible} onClose={closeModal} width={300}>
        <div>
          <SimpleInput
            label={"團隊成員"}
            value={member}
            onChange={(e) => {
              updateData("member", e.target.value);
            }}
          />
        </div>
        <div>
          <SimpleInput
            label={"負責範圍"}
            value={scope}
            onChange={(e) => {
              updateData("scope", e.target.value);
            }}
          />
        </div>
        <div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="截止日期"
              value={deadline}
              onChange={(newValue) => {
                updateData("deadline", newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
              InputProps={{
                style: {
                  fontSize: 14,
                  height: 35,
                },
              }}
            />
          </LocalizationProvider>
        </div>
        <ButtonRow>
          <Button
            onClick={() => {
              createNewTask();
            }}
          >
            儲存
          </Button>
        </ButtonRow>
      </Modal>
    </div>
  );
};

export default observer(MilestoneDetail);
